<template>
  <div class="section-container" id="about-us">
    <div class="section-container-header-box fade-up-animation">
      <p class="list-text">About Us</p>
    </div>
    <h2 class="section-container-heading">
      <p
        v-for="(line, index) in lines"
        :key="line.text"
        class="extra-large-text-list fade-up-animation"
        :class="{ 'special-text': line.special }">
        {{ line.text }}
      </p>
    </h2>

    <div class="about-us-intro-details">
      <div class="about-us-intro-details-box fade-up-animation">
        <div class="about-us-intro-details-box-certificates">
          <img src="/assets/certificates/digital-ocean-partner.svg" alt="" />
        </div>
      </div>
      <div class="about-us-intro-details-box fade-up-animation">
        <p class="body-text">
          At Vortec, we believe every idea deserves the chance to grow. Whether it’s the seed of a startup or the
          strategy of a global enterprise. Our work lives at the intersection of imagination and engineering, where
          vision is translated into digital products that truly matter. From agile tools that help young companies take
          their first steps, to complex systems that keep corporations moving forward, we shape technology around
          people, purpose, and progress.
        </p>
        <nuxt-link to="/about" aria-label="Navigate to About Us page" class="arrow-button">
          <p class="list-text-bold">About us</p>
          <div class="arrow-button-icon" v-html="[icons.rightArrowIcon, icons.rightArrowIcon]"></div>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useFadeUpObserver } from '@/composables/useFadeUpObserver';
import icons from '~/icons';

const lines = [
  { text: 'Driven by', special: false },
  { text: 'Purpose.', special: true },
  { text: 'Fueled by', special: false },
  { text: 'Technology.', special: true },
  { text: 'Shaping the', special: false },
  { text: 'Future.', special: true },
];

useFadeUpObserver();
</script>
